/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr, Tooltip } from "../../../revvComponents";

// Component Imports
import TemplateTableBody from "./TemplateTableBody";
import TemplatesStatusFilterPopup from "./TemplatesStatusFilterPopup";
import TemplateHeader from "../TemplateHeader";
import TemplateFilterTags from "./TemplateFilterTags";

// Service Imports
import { DocumentTemplateActions, UserActions } from "../../../actions";

// Internal Imports
import { GlobalUtils, AmplitudeUtils } from "../../../utils";
import { EVENTS, LOADING_MSG, TEMPLATE } from "../../../constants";
import { USER_ROLES } from "../../../constants/roleList";

import TemplateSearchTags from "../TemplateSearchTags/TemplateSearchTags";
import LZLoader from "../../../commonComponents/LZLoader";

// Destructuring
const { handleApiErrMsg, readDataFromLocalStorage } = GlobalUtils;
const {
  updateStatusFilters,
  fetchAllDocumentTemplates,
  clearTemplateSearchTerm,
  updateTemplateSearchContent,
} = DocumentTemplateActions;
const { amplitudeLogEvent } = AmplitudeUtils;
const { initTeammatesSettingsData } = UserActions;
const { TEMPLATE_STATUSES_FOR_FILTER: TEMP_STATUSES } = TEMPLATE;

const ORG_TEMPLATES = "organization";

class OrgTemplates extends Component {
  state = {
    showLoader: false,
    showSearchPage: false,
    showStatusFilterPopup: false,
  };

  componentDidMount() {
    amplitudeLogEvent(EVENTS.EVENT_NAMES.MY_TEMPLATE_VIEWED);
    this._loadDocumentTemplates();
    this.props.initTeammatesSettingsData();
  }

  _loadDocumentTemplates = () => {
    this.setState({ showLoader: true });
    this.props
      .fetchAllDocumentTemplates()
      .then(() => {
        this.setState({ showLoader: false });
      })
      .catch(error => {
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
        this.setState({ showLoader: false });
        console.error(`OrgTemplates => componentDidMount => ${error}`);
      });
  };

  _toggleSearchPage = flag => {
    this.setState({ showSearchPage: flag });
    if (!flag) {
      this._loadDocumentTemplates();
    }
  };

  _toggleStatusFilterPopup = showStatusFilterPopup => {
    this.setState({ showStatusFilterPopup });
  };

  _clearSearchTerm = () => {
    const { clearTemplateSearchTerm: clearSearchTerm } = this.props;
    this._toggleSearchPage(false);
    clearSearchTerm();
    this.props.updateStatusFilters([]);
    this.props.clearTemplateSearchTerm();
  };

  _applyFiltersAndFetchAssets = filterParams => {
    let payload = "";
    const { searchTerm } = this.props;
    const appliedFilters = filterParams || this.props.templatesStatusFilters;
    if (appliedFilters.length > 0) {
      appliedFilters.forEach((i, idx) => {
        if (idx === 0) {
          payload = `${TEMP_STATUSES[i].status}`;
        } else {
          payload = `${payload},${TEMP_STATUSES[i].status}`;
        }
      });
    }
    if (searchTerm) {
      this.props.updateTemplateSearchContent(searchTerm, false, 0, payload);
    } else {
      this.props.fetchAllDocumentTemplates(1, false, payload);
    }
  };

  _removeFilter = item => {
    const { templatesStatusFilters } = this.props;
    const filtersCopy = [...templatesStatusFilters];
    const index = filtersCopy.indexOf(item);
    if (index > -1) {
      filtersCopy.splice(index, 1);
    }
    this._applyFiltersAndFetchAssets(filtersCopy);
    this.props.updateStatusFilters(filtersCopy);
  };

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");

    if (this.state.showLoader) {
      return <LZLoader label={LOADING_MSG.TEMPLATES} />;
    }
    const { showSearchPage, showStatusFilterPopup } = this.state;
    const { documentTemplates, searchTerm, templatesStatusFilters } =
      this.props;

    let popupSpace = null;

    if (showStatusFilterPopup) {
      popupSpace = (
        <TemplatesStatusFilterPopup
          // folderID={this.props.folderID}
          // opportunityId={this.props.opportunityId}
          templatesStatusFilters={templatesStatusFilters}
          show={showStatusFilterPopup}
          togglePopup={this._toggleStatusFilterPopup}
          applyFilters={this._applyFiltersAndFetchAssets}
          updateStatusFilters={this.props.updateStatusFilters}
        />
      );
    }

    return (
      <div className="templatedetails-container">
        {popupSpace}
        {/** HEADER SECTION */}
        <section className="templates-header">
          <TemplateHeader
            type={ORG_TEMPLATES}
            showSearchPage={showSearchPage}
            toggleSearchPage={this._toggleSearchPage}
          />
        </section>
        {/** BODY SECTION */}
        {showSearchPage ? (
          <TemplateSearchTags
            searchTerm={searchTerm}
            clearSearchTerm={this._clearSearchTerm}
          />
        ) : null}
        {templatesStatusFilters.length > 0 ? (
          <TemplateFilterTags
            templatesStatusFilters={templatesStatusFilters}
            removeFilter={this._removeFilter}
            statuses={TEMP_STATUSES}
          />
        ) : null}

        <section className="orgtemplates-listing-section">
          {/* Table Header */}
          <div className="templatesdetails-table-header">
            <div className="templatedetails-header-wrap">
              <div className="templatedetails-header-item  td-col-label">
                <div className="templatedetails-table-text">
                  Title
                  {/* <FontAwesomeIcon
                    icon={["far", "angle-down"]}
                    className="templatedetails-down-icon"
                  /> */}
                </div>
              </div>
              {CURRENT_USER &&
                Array.isArray(CURRENT_USER.roles) &&
                CURRENT_USER.roles[0].name === USER_ROLES.ADMIN && (
                  <div className="templatedetails-header-item  td-col-tag tag-usergroup">
                    <Tooltip
                      placement="right"
                      align={{
                        offset: [0, 10],
                      }}
                      mouseLeaveDelay={0}
                      overlay="Manage visibility of templates based on  user groups.">
                      <div className="templatedetails-table-text tag">
                        User groups
                      </div>
                    </Tooltip>
                  </div>
                )}
              <div className="templatedetails-header-item  td-col-tag">
                <div className="templatedetails-table-text tag">
                  Tags
                  {/* <FontAwesomeIcon
                    icon={["far", "angle-down"]}
                    className="templatedetails-down-icon"
                  /> */}
                </div>
              </div>
              <div className="templatedetails-header-item  td-col-status">
                <div className="templatedetails-table-text">
                  Status
                  <span onClick={() => this._toggleStatusFilterPopup(true)}>
                    <FontAwesomeIcon
                      icon={["fal", "filter"]}
                      className="template-filter-icon"
                    />
                  </span>
                  {/* <FontAwesomeIcon
                    icon={["far", "angle-down"]}
                    className="templatedetails-down-icon"
                  /> */}
                </div>
              </div>
              <div className="templatedetails-header-item  td-col-modifiedby">
                <div className="templatedetails-table-text">
                  Modified By
                  {/* <FontAwesomeIcon
                    icon={["far", "angle-down"]}
                    className="templatedetails-down-icon"
                  /> */}
                </div>
              </div>
              {/* <div className="templatedetails-add-btn">
            <div className="plusiconadd">
              <FontAwesomeIcon icon={["far", "plus"]} />
            </div>
          </div> */}
            </div>
          </div>
          {/* Table Body */}
          <div className="templatebody-scrollable">
            <TemplateTableBody
              showSearchPage={showSearchPage}
              templates={documentTemplates}
              templatesStatusFilters={templatesStatusFilters}
            />
          </div>
        </section>
        {/* Empty Search Results */}

        {showSearchPage && documentTemplates && !documentTemplates.length ? (
          <div className="template-search-no-results">No results found</div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { documentTemplates, searchTerm, templatesStatusFilters } =
    state.TemplateStore;
  return {
    documentTemplates,
    searchTerm,
    templatesStatusFilters,
  };
};

const mapDispatchToProps = {
  updateStatusFilters,
  fetchAllDocumentTemplates,
  clearTemplateSearchTerm,
  initTeammatesSettingsData,
  updateTemplateSearchContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgTemplates);
